import React from 'react';
import { Typography, Tooltip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import { connect } from 'react-redux';
import utils from '../../../utils/utils';
import { makeStyles } from 'tss-react/mui';
import { MomentInput } from 'moment';

// redux additions

const styles = makeStyles()((theme) => {
    return {
        unit: {
            marginLeft: 5,
        },
        paper: {
            width: '80%',
            maxHeight: 435,
        },
    };
});

const gram = 'gm';
const kgPerSquareMeter = 'kg/m2';

const unitsMapper = {
    brain: gram,
    heart: gram,
    leftKidney: gram,
    rightKidney: gram,
    liver: gram,
    leftLung: gram,
    rightLung: gram,
    spleen: gram,
    thymus: gram,
    bmi: kgPerSquareMeter,
    weight: (obj) => (obj.age < 2 ? gram : 'lb'),
    height: (obj) => (obj.age < 2 ? 'cm' : ''),
};

// const gramFormatter = (value) =>
//     value ? `${Math.round(value * 10) / 10}` : null;
const areaFormatter = (code, areas) =>
    areas && areas.length && areas.find((c) => c.code === code).name;
const booleanFormatter = (value) =>
    value ? <CheckCircleOutlineIcon /> : <CancelOutlinedIcon />;
const locationFormatter = (value) =>
    value.parsedAddress || value.originalAddress;
const ageFormatter = (value) => Math.floor(value);
const heightFormatter = (value, obj) =>
    obj.age < 2
        ? value
        : value
        ? `${Math.floor(value / 12)}' ${
              value % 12 < 11 ? Math.ceil(value % 12) : 11
          }''`
        : null;

const companionFormatter = (value) =>
    value.map((v, i) => {
        let id = v;
        if (v.includes('/')) {
            id = v.split('/').pop();
        }

        // @ts-ignore
        return (
            <a
                href={`${window.location.pathname}?id=cases&caseId=${id}`}
                style={{ color: '#999ba8' }}
            >
                <Typography key={`companion-${i}`}>{id}</Typography>
            </a>
        );
    });

const icd10Formatter = (value, obj, field) =>
    value.map((v, idx) => (
        <Tooltip title={v.substring(v.indexOf(';') + 1)}>
            <Typography key={`field-${idx}`}>
                {v.substring(0, v.indexOf(';'))}
            </Typography>
        </Tooltip>
    ));

export const formatter = {
    bmi: (value) => value.toFixed(2),
    weight: (value) => value,
    trialId: (value) => (
        <a
            href={`https://www.clinicaltrials.gov/study/${value}`}
            target={'_blank'}
            rel="noreferrer"
            style={{
                textDecoration: 'none',
                color: 'gray',
                borderBottom: '1px dotted',
            }}
        >
            {value}
        </a>
    ),
    isTrial: booleanFormatter,
    age: ageFormatter,
    county: areaFormatter,
    residence: locationFormatter,
    height: heightFormatter,
    lastModified: (value) => utils.formatDate(value),
    dateOfBirth: (value: MomentInput): string => {
        if (Array.isArray(value) && value.length === 3) {
            const [year, month, day] = value as [number, number, number];
            return utils.formatDate([year, month - 1, day], 'L');
        }
        return utils.formatDate(value, 'L');
    },
    dateOfDeath: (value) => utils.formatUtcDate(value, 'L'),
    causeOfDeath_ICD10: icd10Formatter,
    contributingFactors_ICD10: icd10Formatter,
    placeOfDeath: locationFormatter,
    placeOfInjury: locationFormatter,
    companionIds: companionFormatter,
    tumorAreas: (value) => value.join(', '),
    diagnosis: (value) => value.join(', '),
    geneMutations: (value) => value.join(', '),
    otherConditions: (value) => value.join(', '),
};

const FormattedField = ({ obj, value, field, primaryAction, ...props }) => {
    const { classes } = styles();
    if (value || obj) {
        return (
            <span>
                {formatter[field]
                    ? formatter[field](
                          value || obj[value],
                          obj || props.areas,
                          field,
                          primaryAction
                      )
                    : value}
                {unitsMapper[field] && (
                    <Typography variant="caption" className={classes.unit}>
                        {typeof unitsMapper[field] === 'function'
                            ? unitsMapper[field](obj)
                            : unitsMapper[field]}
                    </Typography>
                )}
            </span>
        );
    }

    return null;
};

const mapStateToProps = (state) => ({
    areas: (state.userAccess && state.userAccess.areas) || [],
});

export default connect(mapStateToProps, null)(FormattedField);
